import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cssFlag: true,
};

export const cssSlice = createSlice({
  name: "setFlagForHomePage",
  initialState,
  reducers: {
    cssReducer: (state, action) => {
      state.cssFlag = action.payload;
    },
  },
});
export const { cssReducer } = cssSlice.actions;
export default cssSlice;